import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import tokenService from '@sophocles/services/token';

export default function LogoutPage() {
  const { t } = useTranslation();
  useEffect(async () => {
    tokenService.logout();
    window.location.href = '/login';
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
      <Typography>{t('auth.signingOut', 'Signing you out...')}</Typography>
    </Box>
  );
}
